export default __webpack_public_path__ + "static/media/iza_lashes.d32b47cc.jpg";